<template>
  <div class="orderCountTable">
    <el-table
      :data="data"
      :summary-method="getSummaries"
      show-summary
      border
      style="width: 100%"
      max-height="500"
    >
      <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
      <el-table-column prop="push_time_date" label="推送时间"></el-table-column>
      <el-table-column prop="shop_name" label="三方名称"></el-table-column>
      <el-table-column label="订单">
        <el-table-column prop= "sum_order_amount" label="供货金额"></el-table-column>
      </el-table-column>
      <el-table-column label="售后">
        <el-table-column prop= "sum_ap_amount" label="售后确认金额"></el-table-column>
      </el-table-column>
      <!-- <el-table-column label="活动">
        <el-table-column prop= "" label="活动金额"></el-table-column>
      </el-table-column> -->
      <el-table-column label="订单">
        <el-table-column prop= "sum_order_quantity" label="供货数量">
          <template slot-scope="scope">
              <span>{{scope.row.sum_order_quantity | fixedNumber}}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="售后">
        <el-table-column prop= "sum_ap_quantity" label="售后确认单数">
          <template slot-scope="scope">
              <span>{{scope.row.sum_ap_quantity | fixedNumber}}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- <el-table-column label="活动">
        <el-table-column prop= "" label="活动单数"></el-table-column>
      </el-table-column> -->
      <!-- <el-table-column prop= "" label="当日金额合计"> </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
const isType = type => target => `[object ${type}]` === Object.prototype.toString.call(target)
const isNumber = isType('Number')
export default {
  props: ['data'],
  data () {
    return {}
  },
  filters: {
    fixedNumber (val) {
      let value = Number(val)
      return isNaN(isNumber(value)) ? '' : parseFloat(value)
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (index === 0) {
          sums[index] = '合计'
        } else if (index === 3) {
          // sums[index] = this.data.total_amount
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
        } else if (index === 4) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
          // sums[index] = this.data.total_price
        } else if (index === 5) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0))
          } else {
            sums[index] = ''
          }
          // sums[index] = this.data.total_price
        } else if (index === 6) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0))
          } else {
            sums[index] = ''
          }
          // sums[index] = this.data.total_price
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/AmountGoodsTable.vue